export const appShell = {
  nav: {
    fleetManagement: 'Fleet Management',
    vehicles: 'Vehicles',
    contracts: 'Contracts',
    drivers: 'Drivers',
    developer: 'Developer',
    demo: 'Demo',
    organization: 'Organization',
    users: 'Users',
    locations: 'Locations',
  },
  userMenu: {
    account: 'Account',
    billing: 'Billing',
    notifications: 'Notifications',
    legal: 'Legal',
    logout: 'Log out',
  },
  // Shared between the account-dropdown Legal submenu and the sign-in screen
  // footer — keep it neutral, not scoped to either surface's own labels.
  legal: {
    privacy: 'Privacy',
    imprint: 'Imprint',
  },
  signingOut: 'Signing out…',
  // Endonyms: a language's own name for itself, so the aria-label reads the same
  // whichever language the UI is in. The DE/EN abbreviations are never translated.
  language: {
    german: 'Deutsch',
    english: 'English',
  },
};

export type AppShellResources = typeof appShell;
